export class ConclusoesFichasModel {
  id_conclusao: number;
  conclusao_pt: string;
  conclusao_en: string;
  conclusao_es: string;
}



// WEBPACK FOOTER //
// ./src/app/conclusoes-fichas/conclusoes-fichas.model.ts